"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isManifest = isManifest;
exports.isManifestObject = isManifestObject;
exports.isWebrtcFormat = isWebrtcFormat;
exports.isGenericFormat = isGenericFormat;
exports.isValidFormat = isValidFormat;
function isManifest(object) {
    if (object == null) {
        return false;
    }
    if (typeof object === "string") {
        return object.startsWith("http://") || object.startsWith("https://") || object.startsWith("://");
    }
    if (typeof object === "object") {
        return "formats" in (object !== null && object !== void 0 ? object : {});
    }
    return false;
}
function isManifestObject(object) {
    if (object == null) {
        return false;
    }
    if (typeof object === "object") {
        return "formats" in (object !== null && object !== void 0 ? object : {});
    }
    return false;
}
function isWebrtcFormat(val) {
    const obj = val;
    return typeof obj === "object" && typeof obj.origin === "object" && typeof obj.origin.callId === "string";
}
function isGenericFormat(val) {
    const obj = val;
    return typeof obj === "object" && (Array.isArray(obj.encodings) || obj.substitute != null);
}
function isValidFormat(val) {
    return isWebrtcFormat(val) || isGenericFormat(val);
}
//# sourceMappingURL=manifest.js.map